import React from 'react';
import { useCheckout } from './CheckoutContext';
export function Hero() {
  const {
    openUpsell
  } = useCheckout();
  return <section className="relative px-4 pt-5 pb-7 sm:pt-7 sm:pb-9" data-id="element-103">
      <div className="max-w-4xl mx-auto text-center" data-id="element-104">
        {/* Badges */}
        <div className="flex flex-wrap items-center justify-center gap-1.5 mb-3" data-id="element-105">
          <div className="inline-block px-3 py-1 rounded-full border border-brand-gold/30 bg-brand-gold/5 text-[10px] sm:text-xs text-brand-gold" data-id="element-106">
            +18.000 personas ya aplicaron este método
          </div>
          <div className="inline-block px-3 py-1 rounded-full border border-brand-gold/30 bg-brand-gold/5 text-[10px] sm:text-xs text-brand-gold" data-id="element-107">
            Método de transformación consciente
          </div>
        </div>

        {/* Main Title */}
        <h1 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-2 leading-[1.05]" data-id="element-108">
          TODO LO QUE PEDISTE <span className="text-brand-gold" data-id="element-109">YA EXISTE</span>
        </h1>

        {/* Subtitle */}
        <p className="text-sm sm:text-base md:text-lg text-brand-gold mb-4 sm:mb-5 font-light max-w-2xl mx-auto" data-id="element-110">
          Lo único que falta es convertirte en la persona capaz de recibirlo.
        </p>

        {/* Product Image */}
        <div className="relative mb-4 sm:mb-5" data-id="element-111">
          <div className="absolute inset-0 bg-brand-gold/10 blur-3xl rounded-full" data-id="element-112"></div>
          <img src="https://cdn.magicpatterns.com/uploads/he8gmTMdC2UcJ2rVNz4L4j/f1c93867-5d49-4857-b337-8bbad8fa489b.png" alt="Realmanifestación - Manifestación Consciente" className="relative w-full max-w-lg mx-auto" data-id="element-113" />
        </div>

        {/* Price */}
        <div className="mb-3" data-id="element-114">
          <p className="text-brand-gray line-through text-sm sm:text-base mb-0" data-id="element-115">
            $50.000 ARS
          </p>
          <p className="text-brand-gold text-3xl sm:text-4xl font-bold leading-tight" data-id="element-116">
            $19.990 ARS
          </p>
        </div>

        {/* Bullets */}
        <div className="grid grid-cols-2 gap-x-4 gap-y-1.5 max-w-md mx-auto mb-5 text-left" data-id="element-117">
          {['Acceso inmediato', 'Formato digital', 'Compatible celular y PC', 'Garantía de 7 días'].map((item, i) => <div key={i} className="flex items-center gap-2 text-xs sm:text-sm" data-id="element-118">
              <span className="text-brand-gold" data-id="element-119">✓</span>
              <span data-id="element-120">{item}</span>
            </div>)}
        </div>

        {/* CTA Button */}
        <button onClick={openUpsell} className="w-full sm:w-auto bg-brand-gold text-brand-black px-8 py-3.5 sm:px-10 sm:py-4 rounded text-base sm:text-lg font-bold hover:opacity-90 transition-all hover:scale-[1.02] mb-2" data-id="element-121">
          QUIERO ACCESO INMEDIATO
        </button>

        {/* Trust Badge */}
        <p className="text-[11px] sm:text-xs text-brand-gray" data-id="element-122">
          Pago 100% seguro · SSL
        </p>
      </div>
    </section>;
}